/**
 * @file main.tsx
 * @brief Entry point — mounts the React tree onto `#root`.
 *
 * @author DES
 * @date 26-05-2026
 */

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { desktopShell } from "./shared/desktop/desktopShell";

// Marks the Mac app (html.desktop-app). It filled its window 19-10 and is on
// the centred 80rem column again since 20-10 (--shell-rail-max, index.css).
if (desktopShell()) document.documentElement.classList.add("desktop-app");

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root container '#root' not found in index.html");
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
